// extracted by mini-css-extract-plugin
module.exports = {"FilmProgram":"FilmProgram_FilmProgram__4UtZ7","ProgramTitle":"FilmProgram_ProgramTitle__qYbfL","DataLoader":"FilmProgram_DataLoader__ssID0"};